import React from 'react';
import styles from './Bottle.module.css';

const Bottle = () => {
  return (
    <div className={styles.bottle}>
      <img src="/bottle.png" alt="Technexus Bottle" />
    </div>
  );
};

export default Bottle;